export default "__VITE_ASSET__fY3aTK$M__"